import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGooglePay = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 13,
	viewBox: "0 0 30 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_11313_41252)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M14.1892 6.36173V9.88115H13.0813V1.19288H16.0194C16.7281 1.17915 17.4094 1.44905 17.9255 1.94808C18.4415 2.41236 18.7304 3.08432 18.7168 3.77731C18.7304 4.47716 18.4415 5.14911 17.9255 5.62026C17.4094 6.112 16.7766 6.36173 16.0267 6.36173H14.1892ZM14.1892 2.26004V5.29458H16.0471C16.46 5.30831 16.8589 5.14225 17.141 4.84403C17.7256 4.27591 17.7329 3.34049 17.1687 2.75178L17.141 2.72388C16.8589 2.41923 16.46 2.25274 16.0471 2.26647C16.0471 2.2669 14.1892 2.26004 14.1892 2.26004ZM21.2693 3.74255C22.0879 3.74255 22.7347 3.96439 23.2094 4.40078C23.6841 4.84403 23.9181 5.44691 23.9181 6.21584V9.87385H22.8583V9.04956H22.8101C22.3491 9.72839 21.7436 10.0682 20.9799 10.0682C20.3331 10.0682 19.783 9.87428 19.3492 9.48638C18.9226 9.12594 18.6818 8.59258 18.6955 8.03133C18.6955 7.41472 18.9294 6.92985 19.3905 6.56255C19.8516 6.19524 20.4707 6.01502 21.2412 6.01502C21.9016 6.01502 22.4381 6.13989 22.8651 6.37546V6.11929C22.8651 5.73826 22.6998 5.37782 22.4109 5.13538C22.1151 4.87192 21.7367 4.72646 21.3443 4.72646C20.7251 4.72646 20.2364 4.98992 19.872 5.51642L18.8949 4.89981C19.425 4.13045 20.2163 3.74255 21.2693 3.74255ZM19.8379 8.05879C19.8379 8.34972 19.9756 8.62004 20.2027 8.7861C20.4503 8.98005 20.7532 9.08389 21.0626 9.07703C21.5305 9.07703 21.9775 8.88994 22.3082 8.5574C22.6729 8.21112 22.8587 7.80219 22.8587 7.33105C22.5148 7.05386 22.0329 6.91526 21.4137 6.91526C20.9663 6.91526 20.5879 7.02597 20.2854 7.24094C19.9892 7.46321 19.8379 7.73354 19.8379 8.05879ZM30.0001 3.9365L26.2984 12.4999H25.1564L26.5323 9.50698L24.097 3.94337H25.3013L27.0556 8.21112H27.0833L28.7963 3.94337L30.0001 3.9365Z",
				fill: "#60646A"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.71026 5.59926C9.71026 5.25985 9.68256 4.92044 9.62759 4.58789H4.95557V6.50722H7.63205C7.52211 7.12383 7.16417 7.67821 6.64131 8.02449V9.27143H8.23758C9.17334 8.40553 9.71026 7.12383 9.71026 5.59926Z",
				fill: "#517CBE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.95552 10.4771C6.29014 10.4771 7.41851 10.0338 8.23752 9.27174L6.64126 8.0248C6.19383 8.32946 5.62283 8.50281 4.95552 8.50281C3.6618 8.50281 2.56794 7.62274 2.17591 6.44531H0.531494V7.73388C1.37096 9.40991 3.0844 10.4771 4.95552 10.4771Z",
				fill: "#32A853"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.1759 6.44471C1.96965 5.82811 1.96965 5.15615 2.1759 4.53268V3.25098H0.531483C-0.177161 4.65754 -0.177161 6.32027 0.531483 7.72684L2.1759 6.44471Z",
				fill: "#FBBC0C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.95552 2.47457C5.66416 2.46084 6.34553 2.73074 6.85433 3.22291L8.2648 1.80261C7.37079 0.950433 6.18744 0.486155 4.95552 0.500315C3.08398 0.500315 1.37096 1.56747 0.531494 3.2508L2.17591 4.53936C2.56837 3.35464 3.66223 2.47457 4.95552 2.47457Z",
				fill: "#E84436"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_11313_41252",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 30,
			height: 12,
			fill: "white",
			transform: "translate(0 0.5)"
		})
	}) })]
});
export default SvgGooglePay;
